import { useMemo } from "react";
import { useLocale } from "@acto/web-common/locales";
import type { TeamMarkedDoneChannel } from "@acto/gql/graphql";
import type { MarkedDoneSummary } from "@acto/taskpane/core/domain/TeamEmployee";

export interface MarkedDoneItem {
  id: string;
  date: string;
  clientId: string | null;
  clientName: string | null;
  clientExternalReference: string | null;
  clientAccessible: boolean;
  channel: TeamMarkedDoneChannel | null;
  reportExcerpt: string | null;
}

export interface MarkedDoneData {
  employeeName: string;
  period: string;
  count: number;
  items: MarkedDoneItem[];
}

export function useMarkedDoneData(
  markings: MarkedDoneSummary[] | null,
  employeeName: string,
  period: string,
): MarkedDoneData | null {
  const { locale } = useLocale();

  return useMemo(() => {
    if (!markings) return null;

    const items = [...markings]
      .sort((a, b) => a.markedDoneAt.valueOf() - b.markedDoneAt.valueOf())
      .map((m) => ({
        id: m.id,
        date: m.markedDoneAt.locale(locale).format("D MMM"),
        clientId: m.clientId,
        clientName: m.clientName,
        clientExternalReference: m.clientExternalReference,
        clientAccessible: m.clientAccessible,
        channel: m.channel,
        reportExcerpt: m.reportExcerpt,
      }));

    return { employeeName, period, count: items.length, items };
  }, [markings, employeeName, period, locale]);
}
